import script from "./ActivationsOffline.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActivationsOffline.vue?vue&type=script&setup=true&lang=ts"

import "./ActivationsOffline.vue?vue&type=style&index=0&id=0e9ffb20&lang=css"

export default script